import { render, staticRenderFns } from "./MonthlyEPFHSBC.vue?vue&type=template&id=f57d4526&scoped=true"
import script from "./MonthlyEPFHSBC.vue?vue&type=script&lang=js"
export * from "./MonthlyEPFHSBC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57d4526",
  null
  
)

export default component.exports